import mount from "../utils/mount";
import Template900Container from "./Template900Container";

import "./css/app.css";
import "./css/custom.css";

//import "./css/all.css";
//import "./css/custom.css";

mount(Template900Container);
